export default __webpack_public_path__ + "static/media/facebook.bb73dfb4.svg";